export default "__VITE_ASSET__0uAYdT18__"